var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { getIconSettledProps, useInsertStyles } from '../utils';
import IconContext from './IconContext';
var IconDefault = function (props) {
    var Component = props.component, children = props.children, xicon = props.xicon, restProps = __rest(props, ["component", "children", "xicon"]);
    var prefixCls = React.useContext(IconContext).prefixCls;
    var _a = getIconSettledProps(__assign(__assign({}, restProps), { prefixCls: prefixCls })), spanProps = _a.spanProps, svgProps = _a.svgProps;
    var childComp = null;
    if (Component) {
        childComp = React.createElement(Component, __assign({}, svgProps), children);
    }
    if (children) {
        childComp = React.createElement("svg", __assign({}, svgProps), children);
    }
    if (xicon) {
        childComp = xicon;
    }
    useInsertStyles();
    return (React.createElement("span", __assign({}, spanProps), childComp));
};
export default IconDefault;
